<div class="row" style="position: fixed;">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <ul class="breadcrumb">
            <!-- <li>
                <h4 class="page-title">{{title}}</h4>
            </li> -->
            <li class="breadcrumb-item bcrumb-1">
                <a [routerLink]="'/admin/dashboard/main'">
                    <!-- <i class="fas fa-home"></i>   -->
                    <i-feather name="home" class="breadcrumb-icon"></i-feather>
                </a>
            </li>
            <li class="breadcrumb-item" *ngIf="module"><a [routerLink]="moduleLink">{{module }}</a></li>
            <li class="breadcrumb-item" *ngIf="subModule" ><a style="cursor: pointer;" (click)="subModuleClick()">{{subModule }}</a></li>
            <li class="breadcrumb-item" *ngIf="subModule1" ><a style="cursor: pointer;" (click)="subModuleClick1()">{{subModule1 }}</a></li>
            <li class="breadcrumb-item" *ngIf="items1"><a [routerLink]="itemLink">{{ items1 }}</a></li>
            <li class="breadcrumb-item" *ngFor="let item of items">{{item }}</li>
            <li class="breadcrumb-item active" *ngIf="active_item">{{active_item }}</li>
        </ul>
    </div>
</div>